"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Accordion = _interopRequireDefault(require("../Accordion"));
var _Item = _interopRequireDefault(require("./Item"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Menu/Child.js";
function Child(_ref) {
  var _this = this;
  var menu = _ref.menu,
    onClick = _ref.onClick;
  var name = menu.name,
    icon = menu.icon,
    label = menu.label,
    route = menu.route,
    id = menu.id;
  var key = id || label || name.replaceAll(' ', '');
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
    key: key,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: "nav-item",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    eventKey: key,
    className: "nav-link font-size-sm text-truncate",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-inline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 25
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ms-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 25
    }
  }, label || name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "float-end p-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-chevron-down",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 25
    }
  })))), /*#__PURE__*/_react["default"].createElement(_Accordion["default"].Collapse, {
    eventKey: key,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "navbar-nav ms-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 17
    }
  }, route.map(function (m, i) {
    return /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      menu: m,
      onClick: onClick,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 32
      }
    });
  }))));
}
var _default = exports["default"] = Child;